import { type FunctionComponent } from 'react'

import { type TabProps } from './types'

export const InteractiveTab: FunctionComponent<
  React.PropsWithChildren<TabProps>
> = ({ children }) => {
  return <>{children}</>
}
